import { ValueOf } from '@/shared/lib/interfaces/utils';

export const SCOPED_ROLE = {
	ADMIN: 'Admin',
	EMPLOYEE: 'Employee',
	OWNER: 'Owner',
	CAPTAIN: 'Captain',
	CREW: 'Crew',
	GUEST: 'Guest',
	OTHER: 'Other',
} as const;

export type SCOPED_ROLE = ValueOf<typeof SCOPED_ROLE>;
